module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "stage stage--full-size",
    attrs: {
      "data-stage": "5"
    }
  }, [(_vm.opened) ? _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    ref: "scrollElm",
    staticClass: "scroll-height",
    on: {
      "scroll": _vm.checkIfNeedsMore
    }
  }, [_c('div', {
    ref: "altContainer"
  }, [(_vm.alternatives.length) ? _vm._l((_vm.alternatives), function(day) {
    return _c('alt-slot', {
      key: day.date.getTime(),
      attrs: {
        "day": day,
        "header": _vm.DateService.friendlyDate(day.date),
        "times": day.times,
        "placeholder": null
      },
      on: {
        "seeMore": function($event) {
          _vm.seeMore(day.date)
        },
        "selectTime": _vm.selectTime
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _vm._l((7), function(n) {
    return _c('alt-slot', {
      key: n,
      attrs: {
        "placeholder": true
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.appendInProgress) ? _c('alt-slot', {
    attrs: {
      "placeholder": true
    }
  }) : _vm._e()], 2)])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0086143a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/altStage.vue
// module id = 578
// module chunks = 0